import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { usePermissionGuard } from '@/hooks/usePermissionGuard';

interface PermissionGuardProps {
  redirectTo: string;
  children: React.ReactElement;
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  redirectTo,
  children,
}) => {
  const { checkPermission } = usePermissionGuard();
  const { id } = useParams<{ id: string }>();

  const hasAccess = checkPermission();

  if (!hasAccess) {
    const finalRedirect = redirectTo.replace(':id', id || '');
    return <Navigate to={finalRedirect} replace />;
  }

  return children;
};
